import { createWithEqualityFn } from 'zustand/traditional';
import Property from '@app/site/registration/fragment/state/Property';
import SearchHotelResult from '@app/component/form/input/autocomplete/SearchHotelResult';
import FieldError from '@app/site/registration/fragment/state/FieldError';
import Field from '@app/site/registration/fragment/state/Field';
import _isEmpty from 'lodash/isEmpty';
import AdvancedMarkerElement = google.maps.marker.AdvancedMarkerElement;


type PropertiesState = {
    properties: Property[],
    addNewProperty: () => number,
    removeProperty: (index: number) => Property[],
    setProperty: (idx: number, property: Property) => Property[]
    isValid: () => string | undefined,
    markers: AdvancedMarkerElement[],
    setMarkers: (markers: AdvancedMarkerElement[]) => any,
    removeMarkers: () => any
}

const usePropertiesState = createWithEqualityFn<PropertiesState>(
    (set, get) => ({
        isValid: () => validate(get().properties),
        properties: [{hotel: undefined, webhotelierId: undefined, competitors: [undefined]}],
        addNewProperty: () => {
            const copy = [...get().properties];
            const entry: Property = {hotel: undefined, webhotelierId: undefined, competitors: []};
            entry.competitors.push(undefined)
            copy.push(entry)
            set({properties: copy})
            return copy.length - 1;
        },
        removeProperty: (index: number) => {
            const copy = [...get().properties.slice(0, index), ...get().properties.slice(index + 1)];
            if (copy.length === 0) {
                const entry: Property = {hotel: undefined, webhotelierId: undefined, competitors: []};
                entry.competitors.push(undefined)
                copy.push(entry)
            }
            set({properties: copy})
            return copy;
        },
        setProperty: (idx: number, property: Property) => {
            const copy = [...get().properties];
            copy[idx] = property;
            set({properties: copy})
            return copy
        },
        markers: [],
        setMarkers: (markers: AdvancedMarkerElement[]) => {
            const copy = [...get().markers];
            markers.forEach(m => copy.push(m))
            set({markers: copy})
        },
        removeMarkers: () => {
            if (!_isEmpty(get().markers)) {
                get().markers.forEach(m => m.map = null)
            }
            set({markers: []})
        }


    })
);

const error = (error: string, field: Field): FieldError => {
    return {
        error: error,
        field: field
    }
}

const containsProperty = (properties: Property[], hotel: SearchHotelResult) => {
    return properties.findIndex(p => !!p.hotel && p.hotel.id === hotel.id) > -1
}

const validate = (properties: Property[]): string | undefined => {
    if (_isEmpty(properties.filter(p => !!p.hotel))) return "Please add at least one property!";
    for (const p of properties) {
        if (p.hotel === undefined || _isEmpty(p.competitors))
            return "One of the properties is not properly defined!";
    }
    return undefined;
}

export default usePropertiesState;